module.exports = "<app-admin-navbar></app-admin-navbar>\n<router-outlet (activate)=\"onActivate($event)\"></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/base-admin/base-admin.component.html
// module id = ../../../../../src/app/pages/admin/base-admin/base-admin.component.html
// module chunks = main